import ThemeToggle from '@/components/ThemeToggle';

export { Header, Header as default };

function Header() {
  return (
    <header
      className="bg-primary text-primary-foreground shadow-md"
      data-testid="app-header"
    >
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold text-primary-foreground" data-testid="header-title">
            It's a full stack app!
          </h1>
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};
